import React from 'react';
import './index.scss';
class StatusTab extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            // 0草稿，1待审核，2审核通过，3审核未通过，4关闭，5定时发布中,
            tabindex: 0
        }
    }
    tabSwitch = (idx, status) => {
        this.setState({
            tabindex: idx
        })
        this.props.onChange(status);
    }
    render() {
        const { tabindex } = this.state;
        const { tabList } = this.props;
        return (
           <div className='status-tab'>
             <nav className="tabCon">
                    <div className="tabBox">
                    
                        <div className="tabList">
                            {
                                tabList.map((item, idx) => {
                                    return <span key={idx} className={tabindex === idx ? 'active' : ''} onClick={() => this.tabSwitch(idx, item.status)}>{item.text}</span>;
                                })
                            }
                        </div>
                    </div>

                </nav>
           </div>
        );
    }
}
export default StatusTab;
